import React, { useContext } from 'react';
import { Button, TextField } from '@mui/material';
import { CollectRequestContainer, CollectRequestTitle } from './styled';
import { HomeContext } from '../../pages/Home';

export const CollectRequest = () => {
  const { cnpj, handleChangeCnpj } = useContext(HomeContext);

  return (
    <CollectRequestContainer>
      <CollectRequestTitle>Solicite uma coleta</CollectRequestTitle>
      <TextField
        variant="filled"
        label="CNPJ/CPF"
        value={cnpj}
        onChange={handleChangeCnpj}
        style={{ width: 280, backgroundColor: '#ffffff', borderRadius: 4 }}
      />
      <Button
        type="button"
        variant="contained"
        style={{ height: 56, padding: '0 32px', marginLeft: 24 }}
      >
        Enviar
      </Button>
    </CollectRequestContainer>
  );
};
